export const STEPS_COUNT = 2;
export const STEPS_OFFSET = 2;
export const DISPLAYED_STEPS_COUNT = STEPS_COUNT + STEPS_OFFSET;
export const STEPS_OFFSET_WHEN_OPEN_SHIFTS_TEMPLATE = 1;
export const DISPLAYED_STEPS_COUNT_WHEN_OPEN_SHIFTS_TEMPLATE = STEPS_COUNT + STEPS_OFFSET_WHEN_OPEN_SHIFTS_TEMPLATE;
